import React from "react";
import MUIAlert from "@mui/material/Alert";
import styled from "styled-components";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import theme from "../../../Portal/web/Content/js/lib/themes/theme";

const StyledMUIAlert = styled(MUIAlert)`
  border-radius: 16px !important;
  box-shadow: 0px 3px 5px -1px rgba(60, 71, 95, 0.2),
    0px 5px 8px rgba(60, 71, 95, 0.14), 0px 1px 14px rgba(60, 71, 95, 0.12) !important;
  ${({ variant, severity }) =>
    variant == "standard"
      ? `background-color:${theme.palette[severity].light} !important;`
      : ""}

  ${({ variant, severity }) =>
    variant == "standard"
      ? `color:${theme.palette[severity].main} !important;`
      : ""}

  .MuiAlert-message {
    display: flex;
    align-items: center;
    font-size: 15px;
  }
`;

export const Alert = ({
  severity = "success",
  message,
  id,
  variant = "standard",
}) => {
  const size = "large";
  const icons = {
    info: <InfoIcon fontSize={size} />,
    warning: <WarningIcon fontSize={size} />,
    error: <ErrorIcon fontSize={size} />,
    success: <CheckCircleIcon fontSize={size} />,
  };

  return (
    <StyledMUIAlert
      severity={severity}
      variant={variant}
      id={id}
      icon={icons[severity]}
      sx={{ boxShadow: "lg" }}
    >
      {message}
    </StyledMUIAlert>
  );
};
